import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { rpc } from "@/lib/supabase";
import { PageHeader, EmptyState, Loader } from "@/components/kit";
import { ServiceCard } from "@/components/ServiceCard";

export default function DriverHistory() {
  const [list, setList] = useState(null);
  useEffect(() => {
    rpc("get_driver_history").then((d) => setList(d || [])).catch(() => setList([]));
  }, []);
  if (list === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Historial" subtitle="Servicios que has realizado." testId="driver-history" />
      {list.length === 0 ? (
        <EmptyState icon={History} title="Aún no tienes servicios" subtitle="Tus entregas finalizadas aparecerán aquí." testId="empty-driver-history" />
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {list.map((s) => (
            <ServiceCard key={s.id} s={s} testId={`driver-history-${s.id}`} />
          ))}
        </div>
      )}
    </div>
  );
}
